import { render, staticRenderFns } from "./wxmpUserDetail.vue?vue&type=template&id=c769dfba&scoped=true&"
import script from "./wxmpUserDetail.vue?vue&type=script&lang=js&"
export * from "./wxmpUserDetail.vue?vue&type=script&lang=js&"
import style0 from "./wxmpUserDetail.vue?vue&type=style&index=0&id=c769dfba&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c769dfba",
  null
  
)

export default component.exports